export default {
  main_message: 'Voir le fichier README.md pour accès à la documentation',
  name: 'Accueil',
};
